import * as Sentry from '@sentry/astro';

//import.meta.env.MODE -> ist eine von Astro gesetzt env variable die im client verfügbar ist
Sentry.init({
    dsn: 'https://d4e96b57818ccf362d892dbaeaa00d97@o4508613464227840.ingest.de.sentry.io/4508613470060624',
    enabled: import.meta.env.MODE === 'development' || window.location.hostname === 'demo.splonkit.com' ? false : true,
    environment: import.meta.env.MODE === 'development' ? 'DEVELOPMENT' : 'PRODUCTION',
    integrations: [
        Sentry.captureConsoleIntegration({
            levels: ['error']
        })
    ]
});
